module.exports = __webpack_public_path__ + "img/fond.bef3155b.svg";